import PengaturanDimensiHead from "../../../../../components/categories/siakad/laporan_adab/pengaturan_dimensi/HomeHead";
export default function Home() {
  
  return (
    <PengaturanDimensiHead />
  );
}
